"use client";

import { useState } from "react";
import { cn } from "@/src/lib/utils";

import { FaqAccordionItem } from "./FaqAccordionItem";
import type { FaqAccordionProps } from "./FaqAccordion.types";

export function FaqAccordion({ items, defaultOpenIndex = 0, className }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpenIndex);

  const handleToggle = (index: number) => {
    if (openIndex !== index) {
      setOpenIndex(index);
      return;
    }

    setOpenIndex((index + 1) % items.length);
  };

  return (
    <div className={cn(className)}>
      {items.map((item, index) => (
        <FaqAccordionItem
          key={index}
          item={item}
          open={openIndex === index}
          onToggle={() => handleToggle(index)}
          index={index + 1}
        />
      ))}
    </div>
  );
}
